import { render, staticRenderFns } from "./SuspensionCommission.vue?vue&type=template&id=0c885c78&scoped=true"
import script from "./SuspensionCommission.vue?vue&type=script&lang=js"
export * from "./SuspensionCommission.vue?vue&type=script&lang=js"
import style0 from "./SuspensionCommission.vue?vue&type=style&index=0&id=0c885c78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c885c78",
  null
  
)

export default component.exports